import { getBitcoinBoostSafeMode } from '@/shared/graphql/cache/environment';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export const useBoostSafeMode = () => {
  const { data } = useGqlQuery(getBitcoinBoostSafeMode, {
    context: { clientName: 'statechainCache' },
  });

  return {
    isBoostDepositInSafeMode: !data?.allBoostSafeModes?.nodes[0]?.boostDepositsEnabled,
  };
};
